<template>
    <div class="m-fab-bar">
        <button
            class="m-fab"
            v-for="(b, i) in secondary"
            :key="b.key || i"
            @click="$emit('click', b.key, b)"
        >
            <i :class="b.icon || 'el-icon-more'"></i>
        </button>
        <button class="m-fab is-primary" @click="onMain" v-if="showMain">
            <i :class="mainIcon"></i>
        </button>
    </div>
</template>

<script>
/* eslint-disable */
/**
 * m-fab —— 手机端右下角悬浮操作按钮
 *
 * <m-fab main-icon="el-icon-plus" :secondary="[{key:'batch', icon:'el-icon-s-operation'}]"
 *        @main="add" @click="onSecondary" />
 */
export default {
    name: 'MFab',
    props: {
        mainIcon: { type: String, default: 'el-icon-plus' },
        showMain: { type: Boolean, default: true },
        // 次级悬浮按钮 [{ key, icon }]
        secondary: { type: Array, default: () => [] },
    },
    methods: {
        onMain() {
            this.$emit('main');
        },
    },
};
</script>
